import { createEl } from '../lib/dom';
import { SITE } from '../site/site-config';
import { iconAlert, iconBuilding, iconChat, iconMap } from '../ui/icons';

const ICONS = [iconMap, iconChat, iconBuilding, iconAlert] as const;

export function renderFeatures(target: HTMLElement): void {
  const cards = SITE.features.map((f, i) => {
    const iconFn = ICONS[i] ?? ICONS[0];
    const wrap = createEl('div', { className: 'sv-icon-wrap' });
    wrap.appendChild(iconFn());
    return createEl('article', { className: 'sv-card' }, [
      wrap,
      createEl('h3', { className: 'sv-card__title' }, [f.title]),
      createEl('p', { className: 'sv-card__text' }, [f.description]),
    ]);
  });

  const section = createEl(
    'section',
    {
      className: 'sv-section sv-section--surface',
      id: 'funciones',
      'aria-labelledby': 'features-title',
    },
    [
      createEl('div', { className: 'sv-inner' }, [
        createEl('h2', { className: 'sv-section__title', id: 'features-title' }, [SITE.featuresIntro]),
        createEl('div', { className: 'sv-card-grid sv-card-grid--4' }, cards),
      ]),
    ]
  );
  target.appendChild(section);
}
